import React from 'react';
import {useDispatch} from 'react-redux';

import {openCategory} from '../../../modules/admin/docs';
import styles from './stlyes/docs-table.module.css';

import Loading from '../../common/Loading';
import MessageBox from '../../common-women/MessageBox';

import {ReactComponent as CategoryActive} from '../../../assets/docs-women/category-active.svg';
import {ReactComponent as CheckBoxActive} from '../../../assets/docs-women/checkbox-active.svg';
import {ReactComponent as CheckBox} from '../../../assets/docs-women/checkbox.svg';
import {ReactComponent as Error} from '../../../assets/docs-women/error.svg';
import {ReactComponent as NoRegister} from '../../../assets/docs-women/no-register.svg';
import {ReactComponent as NoSearch} from '../../../assets/docs-women/no-search.svg';

export default function DocsTable({ name, listResponse, listError, listLoading, selectedItems, setSelectedItems, changeCurrentId, handleReload, selectItem  }) {
    const dispatch = useDispatch();

    const isAllSelected = listResponse ? listResponse.length === selectedItems.length : false;
    
    const selectAllItems = () => {
        if (listResponse && listResponse.length > 0) {
            setSelectedItems(isAllSelected ? [] : [...listResponse]);
        }
    };

    const clickCategory = (id, type) => { // type이 CATEGORY인 경우에만 currentId를 id로 변경 가능
        if (type === 'CATEGORY') {
            changeCurrentId(id);
            dispatch(openCategory(id));
        }
        return;
    };

    const changeStatus = (status) => {
        if (status === 'PROGRESS') return '학습 중';
        if (status === 'COMPLETED') return '학습 완료';
        if (status === 'FAILURE') return '학습 실패';
        return '';
    };

    const changeDocsType = (docsType) => {
        if (docsType === 'ORIGINAL') return '일반';
        if (docsType === 'TEMPLATE') return 'FAQ 문서';
        return '';
    };

    const validateParams = () => {
        return !!name;
    };

    return (
        <div className={styles.wrapper}>
            {listLoading && <Loading />}

            {!listLoading && listResponse && listResponse.length > 0 &&
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th onClick={selectAllItems} style={{ cursor: 'pointer' }}>
                                {isAllSelected ? <CheckBoxActive /> : <CheckBox />}
                            </th>
                            <th>이름</th>
                            <th>수정한 날짜</th>
                            <th>파일 크기</th>
                            <th>학습 상태</th>
                            <th>분류</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listResponse.map((docsItem) => {
                            const { id, type, name, description, updatedDate, docsSize, status, docsType } = docsItem;
                            const itemKey = `${type}-${id}`;
                            const isSelected = selectedItems.some((item) => `${item.type}-${item.id}` === itemKey);

                            return (
                                <tr className={styles.tableRow} key={itemKey} onClick={() => clickCategory(id, type)}>
                                    <td onClick={(e) => selectItem(e, docsItem)}>
                                        {isSelected ? <CheckBoxActive /> : <CheckBox />}
                                    </td>
                                    <td>
                                        {type === 'CATEGORY' ? <CategoryActive /> : null}
                                        <div className={styles.boxName}>
                                            <p>{name}</p>
                                            <p>{description ? description : ''}</p>
                                        </div>
                                    </td>
                                    <td>{updatedDate}</td>
                                    <td>{docsSize ? docsSize : ''}</td>
                                    <td>
                                        {status 
                                            ? <div className={styles.boxStatus} datatype={status}>
                                                {changeStatus(status)}
                                            </div> 
                                            : null
                                        }
                                    </td>
                                    <td datatype={docsType}>
                                        {changeDocsType(docsType)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            }

            {!listLoading && listResponse && listResponse.length === 0 && validateParams() &&
                <MessageBox
                    height='742px'
                    Icon={NoSearch}
                    message='검색된 결과 없음'
                    subMessage='다른 검색어를 입력해 보세요'
                />
            }

            {!listLoading && listResponse && listResponse.length === 0 && !validateParams() &&
                <MessageBox
                    height='742px'
                    Icon={NoRegister}
                    message='등록된 카테고리 없음'
                    subMessage='새로운 카테고리를 추가해 주세요'
                />
            }

            {!listLoading && listError &&
                <MessageBox
                    height='742px'
                    Icon={Error} 
                    message={<>페이지를 불러오는 중 <span style={{ color: 'red' }}>오류</span> 발생</>}
                    subMessage='재시도'
                    handleReload={handleReload}
                />
            }
        </div>
    );
}
